module.exports = __webpack_public_path__ + "img/A001.edbced11.png";